export interface ProfileAccessOrganization {
  id?: string | number
  root_organizations?: ReadonlyArray<{ id: string | number }>
}

export interface ProfileAccess {
  admins: boolean
  dibs: boolean
  financials: boolean
  memberships: boolean
  messaging: boolean
  profiles: boolean
  rosterHistory: boolean
}

export const DENIED_PROFILE_ACCESS: ProfileAccess = {
  admins: false,
  dibs: false,
  financials: false,
  memberships: false,
  messaging: false,
  profiles: false,
  rosterHistory: false,
}
